import { AxiosError } from "axios";
import { isEmpty } from "lodash";
import ApiResponseError from "src/utils/Api/ApiResponseError";
import { dynamicNotification } from "src/utils/Notifications";
import { EBillingCycleConfigurationType } from "src/Pages/Company/Absences/AbsenceType/AbsenceType.models";
import {
  ErrorCode,
  getCustomErrorMessage,
  getDetailedErrorMessage,
} from "./getCustomErrorMessage";

export interface ErrorDetails {
  billingCycleType?: EBillingCycleConfigurationType;
  [key: string]: any;
}

export const handleValidationError = (
  axiosError: AxiosError<{
    title: string | undefined;
    errors?: Array<{ code: string; message: string; details: ErrorDetails }>;
  }>
) => {
  if ((axiosError.response?.status as number) === 422) {
    const url = axiosError.config?.url;
    const { status } = axiosError;
    let error = axiosError.response?.statusText;
    let responseErrorMessage;
    try {
      const { title, description, message, errorMessage, detail } = axiosError
        .response?.data as {
        title: string;
        description: string;
        message: string;
        errorMessage: string;
        detail: string;
      };
      error = title;
      responseErrorMessage = message || errorMessage || description || detail;
    } catch (e) {
      responseErrorMessage = "Niepoprawna odpowiedź z serwera";
    }
    throw new ApiResponseError(status, url, error, responseErrorMessage);
  } else if (
    axiosError.response?.status === 409 &&
    axiosError.response?.data?.errors
  ) {
    const { errors: errorData } = axiosError.response.data;

    if (Array.isArray(errorData) && errorData.length > 0) {
      const errorWithDetailedMessage = errorData.find((err) => {
        if (err.code) {
          const detailedErrorMessage = getDetailedErrorMessage(err);

          return detailedErrorMessage;
        }
        return false;
      });

      if (errorWithDetailedMessage) {
        const detailedErrorMessage = getDetailedErrorMessage(
          errorWithDetailedMessage
        );

        dynamicNotification(detailedErrorMessage, "error", "top-right", 7000);
      } else {
        const firstErrorWithCode = errorData.find((err) => err.code);

        if (firstErrorWithCode) {
          dynamicNotification(
            getCustomErrorMessage(firstErrorWithCode.code as ErrorCode),
            "error",
            "top-right",
            7000
          );
        }
      }
    }
  } else if (axiosError.response?.status === 429) {
    dynamicNotification(
      "Wystąpił chwilowy błąd. Spróbuj ponownie za chwilę.",
      "error"
    );
  }

  return Promise.reject(axiosError);
};
